import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { EditEventContactComponent } from '../edit-event-contact/edit-event-contact.component';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
var EventContactComponent = /** @class */ (function () {
    function EventContactComponent(_editDescDialog, _toggleService, snackBar, _businessManagerService) {
        this._editDescDialog = _editDescDialog;
        this._toggleService = _toggleService;
        this.snackBar = snackBar;
        this._businessManagerService = _businessManagerService;
        this.editModeSet = false;
        this.isFlightDeckAdmin = false;
    }
    EventContactComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.isFlightDeckAdmin()];
                    case 1:
                        _a.isFlightDeckAdmin = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(EventContactComponent.prototype, "contactEmailAddress", {
        get: function () {
            return 'mailto:' + this.aviationEvent.contactPersonEmail;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventContactComponent.prototype, "contactPhone", {
        get: function () {
            return 'tel:' + this.aviationEvent.contactPersonEmail;
        },
        enumerable: true,
        configurable: true
    });
    EventContactComponent.prototype.openEditTitleDialog = function () {
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '800px';
        dialogConfig.data = { aviationEvent: this.aviationEvent };
        var DIALOG_REF = this._editDescDialog.open(EditEventContactComponent, dialogConfig);
        this._handleModalClose(DIALOG_REF);
    };
    /**
     * listens for dialog close event. Opens snackbar if necessary
     * @param {MatDialogRef<any>} dialogRef
     * @private
     */
    EventContactComponent.prototype._handleModalClose = function (dialogRef) {
        var _this = this;
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogRef.afterClosed().subscribe(function (success) {
            if (success === null) {
                return;
            }
            if (success) {
                _this.snackBar.open('Event Contact', 'Updated', {
                    duration: 3000
                });
            }
            else {
                _this.snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return EventContactComponent;
}());
export { EventContactComponent };
